"use strict";
import "es6-promise/auto";
import Vue from "vue";
import store from "./components/store.js";
import App from "./components/App.vue";

new Vue({
  store,
  el: "#app",
  render: (h) => h(App),
  created() {
    const mainElement = document.getElementById('main');
    if (mainElement) {
      const entryId = mainElement.dataset.entryId;
      console.log("Entry ID:", entryId);
      if (entryId) {
        this.$store.commit("setEntryId", entryId);
        // this.$store.dispatch("fetchDecades", entryId);
      } else {
        console.error("Entry ID not found in data attribute");
      }
    } else {
      console.error("Element with ID 'main' not found");
    }
  },
});



// WEBPACK FOOTER //
// ./timeline/js/main.js